import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import PortalEntryRouter from '@/auth/PortalEntryRouter';
import { installStaleAssetReload } from '@/utils/staleAssetReload';
import './index.css';
// 森林绿主题（令牌层 + AntD 染色层）；仅 <html data-ui="forest"> 时生效
import '@/theme/forest';
import { resolveUiSkin } from '@/theme/forest';

// 早期引导：按本地覆盖 / 环境变量即时设置灰度开关（登录态加载前也能生效，
// 登录后 useTenantTheme 会用租户 extraConfig 再次精修）
document.documentElement.setAttribute('data-ui', resolveUiSkin(null));

installStaleAssetReload();

// 国际化配置
import './locales';

// 启动MSW Mock服务（仅开发环境）
// 临时禁用MSW，因为它会干扰跨域请求的CORS头
async function enableMocking() {
  // if (import.meta.env.DEV) {
  //   const { worker } = await import('./mock/browser');
  //   return worker.start({
  //     onUnhandledRequest: 'bypass', // 不拦截未定义的请求
  //   });
  // }
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <PortalEntryRouter>
        <App />
      </PortalEntryRouter>
    </React.StrictMode>
  );
});
